import ApplicationController from '../application_controller'
import EditableText from 'components/EditableText'
import { createRoot } from 'react-dom/client'

class InterviewController extends ApplicationController {
  connect () {
    // Initialize editable fields
    this._initEditableFields()

    // Listen for React component content ready event
    document.addEventListener('appraisal:content-ready', () => {
      this._initEditableFields()
    })
  }

  _initEditableFields () {
    // Find editable elements by data-controller attribute (editable-text or editable-string)
    $('#rendered-appraisal-interview-template [data-controller="editable-text"], #rendered-appraisal-interview-template [data-controller="editable-string"]').each((i, element) => {
      // Skip if already initialized
      if (element.dataset.initialized === 'true') return

      let text = ''
      const type = $(element).data('type')
      const contentElement = $(element).find('.editable-content')

      if (contentElement.length > 0) {
        text = Helpers.getEditorContent(contentElement.get(0), type)
      }

      const root = createRoot(element)
      root.render(
        <EditableText type={type} text={text} />
      )

      element.dataset.initialized = 'true'
    })
  }
}

export default InterviewController
